function cartHtml() {
  fetch(
    window.Shopify.routes.root +
      "?section_id=sections--16855490297909__cart-drawer"
  )
    .then((response) => response.text())
    .then((responseText) => {
      const cartid = "cart-drawer";
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.querySelector(".cart-drawer");
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;
    });
  document.dispatchEvent(new CustomEvent("cart:refresh"));
  setTimeout(() => {
    const cartCountElement = document.querySelector(".header__cart-count");
    if (cartCountElement) {
      cartCountElement.click();
    }
  }, 300);
}
document.addEventListener("click", function (e) {
  if (e.target.classList.contains("sample-cart")) {
    e.preventDefault();
    var variantId = e.target.getAttribute("data-id");
    fetch(`/cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        quantity: 1,
        id: variantId,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((responseJson) => {
        return fetch(`${Shopify.routes.root}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        })
          .then((response) => response.json())
          .then((cartContent) => {
            cartHtml();
            if (
              window.themeVariables.settings.cartType === "page" ||
              window.themeVariables.settings.pageType === "cart"
            ) {
              window.location.href = `${Shopify.routes.root}cart`;
            }
          });
      })
      .catch((error) => {
        console.error("Error:", error);
        document.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: error.message,
            },
          })
        );
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      });
  }
});

// Price change as per Subscriptions
document.addEventListener("DOMContentLoaded", (event) => {

  if (location.href.includes("/products/")) {
  try {
    var productJson = document.getElementById("product-json");
    if (!productJson) throw new Error("Product JSON element not found!");

    var productData = JSON.parse(productJson.textContent);
    if (!productData || !productData.selling_plan_groups) throw new Error("Invalid product JSON data!");

    document.addEventListener("variant:change", function(event) {
      try {
        if (!event.detail || !event.detail.variant) throw new Error("Variant change event data missing!");
        window.currentVariant = event.detail.variant;
        window.UpdateRcPriceBasedOnRechargeWidget();
      } catch (error) {
        console.error("Error in variant:change event listener:", error);
      }
    });

    window.UpdateRcPriceBasedOnRechargeWidget = function() {
      setTimeout(function() {
        try {
          let sellingPlanId = new URL(location.href).searchParams.get('selling_plan');
          if (!sellingPlanId) throw new Error("Selling plan ID not found in URL!");

          let loopBreak = false;

          for (let spg in productData.selling_plan_groups) {
            for (let spg_sp in productData.selling_plan_groups[spg].selling_plans) {
              let planId = productData.selling_plan_groups[spg].selling_plans[spg_sp].id;
              if (planId == sellingPlanId) {
                let adjustment = productData.selling_plan_groups[spg].selling_plans[spg_sp].price_adjustments[0];
                if (!adjustment || adjustment.value_type !== "percentage") continue;

                let discountPercentage = adjustment.value;
                if (typeof window.currentVariant?.price !== "number") throw new Error("Invalid currentVariant price!");

                let valueAfterPercentageDiscount = window.currentVariant.price - (window.currentVariant.price * (discountPercentage / 100));
                let formattedMoney = (valueAfterPercentageDiscount / 100).toLocaleString(
                  Shopify.locale + "-" + Shopify.country, 
                  { style: 'currency', currency: Shopify.currency.active }
                );

                console.log("Updated After 100 ms!");
                let priceElement = document.querySelector(".product-info__price price-list sale-price");
                if (!priceElement) throw new Error("Price element not found in DOM!");

                priceElement.innerHTML = `<span class="sr-only">Sale price</span> ${formattedMoney}`;
                loopBreak = true;
                break;
              }
            }
            if (loopBreak) break;
          }
        } catch (error) {
          console.error("Error in UpdateRcPriceBasedOnRechargeWidget:", error);
        }
      }, 100);
    };

    function checkElement_rcOnPDP() {
      try {
        let rcSelect = document.querySelector(".rc-widget .rc-selling-plans-dropdown__select");
        let rcCheckbox = document.querySelector(".rc-widget #rc-checkbox1");

        if (rcSelect) {
          clearInterval(intervalId_rcOnPDP);
          rcSelect.addEventListener("change", function() {
            try {
              window.UpdateRcPriceBasedOnRechargeWidget();
            } catch (error) {
              console.error("Error in rc-selling-plans-dropdown change event:", error);
            }
          });
          window.UpdateRcPriceBasedOnRechargeWidget();
        }

        if (rcCheckbox) {
          rcCheckbox.addEventListener("change", function(e) {
            try {
              if (e.currentTarget.checked) {
                rcSelect.addEventListener("change", function() {
                  try {
                    window.UpdateRcPriceBasedOnRechargeWidget();
                  } catch (error) {
                    console.error("Error in rc-selling-plans-dropdown change event:", error);
                  }
                });
                window.UpdateRcPriceBasedOnRechargeWidget();
              } else {
                if (typeof window.currentVariant?.price !== "number") throw new Error("Invalid currentVariant price!");
                let formattedMoney = (window.currentVariant.price / 100).toLocaleString(
                  Shopify.locale + "-" + Shopify.country, 
                  { style: 'currency', currency: Shopify.currency.active }
                );

                let priceElement = document.querySelector(".product-info__price price-list sale-price");
                if (!priceElement) throw new Error("Price element not found in DOM!");

                priceElement.innerHTML = `<span class="sr-only">Sale price</span> ${formattedMoney}`;
              }
            } catch (error) {
              console.error("Error in rc-checkbox change event:", error);
            }
          });
        }
      } catch (error) {
        console.error("Error in checkElement_rcOnPDP:", error);
      }
    }

    const intervalId_rcOnPDP = setInterval(checkElement_rcOnPDP, 1000);

  } catch (error) {
    console.error("Error in product page script:", error);
  }
}


  
});

